import React from 'react'
import SurveyComp from '../../Components/Survey/SurveyComp'


function Survey() {
    return <>
       <SurveyComp />
    </>
}

export default Survey